import { HTMLInputTypeAttribute } from 'react'
import styles from './Input.module.css'

interface InputProps {
    value?: string | null
    type?: HTMLInputTypeAttribute
    placeholder?: string
    ref?: any
    name: string
    options?: any
    onValueChange?: (event: any) => void
    onBlur?: (event: any) => void
}

export const Input = (props: InputProps): JSX.Element => {
    const {
        value = ``,
        placeholder = ``,
        ref,
        type = 'text',
        name,
        options,
        onValueChange,
        onBlur
    } = props

    const handleInputChange = (event: any) => {
        onValueChange?.(event)
    }

    const handleInputBlur = (event: any) => {
        onBlur?.(event)
    }

    return (
        <input
            type={type}
            ref={ref}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            className={styles.Input__Input}
            placeholder={placeholder}
            value={value ? value : ''}
            name={name}
            {...options}
        />
    )
}